const birthYearMask = {
    format: (value) => value.replace(/\D/g, "").substring(0, 4),
    replace: (value) => value.padEnd(4, "_"),
    defaultValue: "____",
};

export { birthYearMask };
